export default __webpack_public_path__ + "static/media/light_code.1378d012.svg";